import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';

var useOpenCloseState = function useOpenCloseState() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = useState(defaultState),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var open = useCallback(function () {
    setIsOpen(true);
  }, []);
  var close = useCallback(function () {
    setIsOpen(false);
  }, []);
  return [isOpen, open, close];
};

export { useOpenCloseState };
